// SVG path data for the Pabs logo
const svgPaths = {
  p19834e00: "M21 25C23.7614 25 26 22.7614 26 20C26 17.2386 23.7614 15 21 15C18.2386 15 16 17.2386 16 20C16 22.7614 18.2386 25 21 25Z",
  pe925160: "M19.4 33.8095C27.9334 35.3809 37 30.1429 37 20.7143C37 12.0355 29.8366 5.00933 21 5.00001C11.8642 4.99037 5.00002 11.8095 5 20.7143C4.99999 31.3514 5.00002 49 5.00002 49",
};

function Logo() {
  return (
    <div className="absolute inset-[13.33%_23.33%]" data-name="Logo">
      <div className="absolute inset-[-11.36%_-15.62%]">
        <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 42 54">
          <g id="Logo">
            <path
              d={svgPaths.pe925160}
              id="Vector"
              stroke="var(--stroke-0, black)"
              strokeLinecap="round"
              strokeWidth="10"
            />
            <path
              d={svgPaths.p19834e00}
              fill="var(--fill-0, black)"
              id="Vector_2"
            />
          </g>
        </svg>
      </div>
    </div>
  );
}

export default function PabloLogo() {
  return (
    <div className="relative size-full" data-name="pablo_logo1.0 1">
      <Logo />
    </div>
  );
}
